import { h } from 'preact'
import PropTypes from 'prop-types'

const PaymentBreakdownItem = ({
  headingText,
  amount,
  subtitleText,
  ...props
}) => (
  <li className="payment-breakdown__item" {...props}>
    <div className="payment-breakdown__payment-info">
      <div className="payment-breakdown__title text bold nospace medium">
        {headingText}
      </div>
      <div className="payment-breakdown__divider" />
      <div className="payment-breakdown__price text bold nospace">{amount}</div>
    </div>
    <div className="payment-breakdown__subtitle text small nospace">
      {subtitleText}
    </div>
  </li>
)

PaymentBreakdownItem.propTypes = {
  headingText: PropTypes.string,
  amount: PropTypes.string,
  subtitleText: PropTypes.string,
  dataTestId: PropTypes.string,
}

export default PaymentBreakdownItem
